import { render, staticRenderFns } from "./PersonnelInfo.vue?vue&type=template&id=6969805f&"
import script from "./PersonnelInfo.vue?vue&type=script&lang=js&"
export * from "./PersonnelInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelInfo.vue?vue&type=style&index=0&id=6969805f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports